import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '@ibk/shared-auth';
import { config } from '@ibk/shared-config';
import { Loading } from '@ibk/shared-ui';
import { detectAppDomain, isMobileUserAgent, parseDeepLinkFromURL, redirectToMobileApp, saveDeepLinkToStorage, } from '@ibk/shared-utils';
export const DeepLinkHandler = () => {
    const navigate = useNavigate();
    const { isAuthenticated, isLoggedIn } = useAuth();
    const [searchParams] = useSearchParams();
    useEffect(() => {
        const handleDeepLink = () => {
            const appDomain = detectAppDomain(config.apiBaseUrl);
            if (isMobileUserAgent()) {
                redirectToMobileApp(appDomain, searchParams);
                navigate('/login', { replace: true });
                return;
            }
            const deepLinkData = parseDeepLinkFromURL(searchParams);
            if (!deepLinkData) {
                navigate('/home', { replace: true });
                return;
            }
            saveDeepLinkToStorage(deepLinkData);
            if (isAuthenticated) {
                navigate('/deeplink-resolver', { replace: true });
            }
            else if (isLoggedIn) {
                navigate('/two-factor-select', { replace: true });
            }
            else {
                navigate('/login', { replace: true });
            }
        };
        handleDeepLink();
    }, [searchParams, isAuthenticated, isLoggedIn, navigate]);
    return _jsx(Loading, { fullScreen: true });
};
